<div role="presentation" #Wrapper (click)="onClick()" class="ui-snackbar-panel {{data.panelClass ?? ''}}">
  {{ data.message }}
  <ui-icon (onClick)="onAction()" class="ml-auto text-primary-400" *ngIf="data.action">
    {{ data.action }}
  </ui-icon>
</div>
